import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import reduxThunk from 'redux-thunk'
import { StateType } from 'typesafe-actions'

import { getAuthMiddleware } from 'packages/auth'
import { sentryReduxEnhancer } from 'packages/common'
import { getOfflineMiddleware } from 'packages/offline'
import { getWireTapMiddle } from 'packages/wiretap'

import {
  createOtherTimerOffline,
  updateOtherTimerOffline,
} from 'app/fieldapp/store/otherTimers/actions'

import { faTrackers } from '../tracking/trackers'
import { setNeedsFullAuthRedirect, setNeedsSilentRefresh } from './auth/actions'
import { getAuthToken, getNeedsSilentRefresh } from './auth/selectors'
import { setRequestHeader } from './axiosInstance'
import { CleanTimesActionTypes } from './cleantimes'
import { createCleanTimeOffline } from './cleantimes/actions'
import { updateCleanTimeOffline } from './cleantimes/actions/updateCleanTime.offline'
import { segmentMiddleware } from './middlewares'
import { OtherTimersActionTypes } from './otherTimers'
import { rootReducer } from './reducers'
import { TicketTimesActionTypes } from './ticket-times'
import { createTicketTimeOffline } from './ticket-times/actions'
import { updateTicketTimeOffline } from './ticket-times/actions/updateTicketTime.offline'

export type ApplicationState = StateType<typeof rootReducer>

const authMiddleware = getAuthMiddleware({
  getAuthToken,
  getNeedsSilentRefresh,
  setNeedsFullAuthRedirect,
  setNeedsSilentRefresh,
  setRequestHeader,
})

const wireTapMiddleware = getWireTapMiddle({ trackers: faTrackers })

const offlineMiddleware = getOfflineMiddleware({
  offlineActions: {
    [OtherTimersActionTypes.UPDATE_OTHER_TIMER]: updateOtherTimerOffline,
    [CleanTimesActionTypes.UPDATE_CLEAN_TIME]: updateCleanTimeOffline,
    [TicketTimesActionTypes.UPDATE_TICKET_TIME]: updateTicketTimeOffline,
    [OtherTimersActionTypes.CREATE_OTHER_TIMER]: createOtherTimerOffline,
    [CleanTimesActionTypes.CREATE_CLEAN_TIME]: createCleanTimeOffline,
    [TicketTimesActionTypes.CREATE_TICKET_TIME]: createTicketTimeOffline,
  },
})
function configureStore() {
  const middlewares = [
    wireTapMiddleware,
    offlineMiddleware,
    reduxThunk,
    authMiddleware,
    segmentMiddleware,
  ]

  const enhancer = composeWithDevTools(
    applyMiddleware(...middlewares),
    sentryReduxEnhancer,
  )

  return createStore(rootReducer, {}, enhancer)
}

const store = configureStore()
export default store
